import api from './api';

export type AiJobKind = 'meeting_transcription' | 'meeting_note_generate' | 'meeting_note_ai_tasks';
export type AiJobStatus = 'queued' | 'running' | 'done' | 'failed';

export type AiJobDto = {
  id: string;
  kind: AiJobKind;
  title: string;
  ownerUserId: string;
  ownerDisplayName: string | null;
  ownerAvatarUrl: string | null;
  meetingGoogleId: string | null;
  meetingTitle: string | null;
  noteId: string | null;
  status: AiJobStatus;
  startedAt: string | null;
  finishedAt: string | null;
  errorMessage: string | null;
  output: any | null;
  createdAt: string;
  updatedAt: string;
};

export type SttActiveSessionDto = {
  meetingGoogleId: string;
  meetingId: number | null;
  meetingTitle: string | null;
  startedBy: { userId: string; displayName: string | null; avatarUrl: string | null };
  startedAt: string;
  participantUserIds: string[];
  jobId: string | null;
};

export type AiTaskItem = { title: string; due_date: string | null };

export async function listAiJobs(): Promise<AiJobDto[]> {
  const res = await api.get('/ai-jobs');
  return (res.data && res.data.data) || [];
}

export async function getAiJob(id: string): Promise<AiJobDto | null> {
  const res = await api.get(`/ai-jobs/${encodeURIComponent(id)}`);
  return (res.data && res.data.success) ? (res.data.data as AiJobDto) : null;
}

export async function runNoteAiTasks(
  noteId: string,
  opts?: { prompt?: string; apiKey?: string }
): Promise<{ items: AiTaskItem[]; jobId: string }> {
  const body: any = {};
  if (opts?.prompt) body.prompt = opts.prompt;
  if (opts?.apiKey) body.apiKey = opts.apiKey;
  const res = await api.post(`/ai-jobs/note/${encodeURIComponent(noteId)}/ai-tasks`, body);
  const data = res.data?.data || {};
  const items = Array.isArray(data.items) ? (data.items as AiTaskItem[]) : [];
  return { items, jobId: String(data.jobId || '') };
}

export async function listActiveSttSessions(): Promise<SttActiveSessionDto[]> {
  const res = await api.get('/stt/active-sessions');
  return (res.data && res.data.data) || [];
}
